import React from 'react'

const ContentColumn = ({children}) => {
  return (
	<div className="flex flex-col w-full space-y-4">
		{children}
	</div>
  )
}

export default ContentColumn